module.exports = __webpack_public_path__ + "img/41.a98fdf9a.jpg";